export default __webpack_public_path__ + "static/media/DNo.35-1.e0bf5cb5.jpg";